module.exports = __webpack_public_path__ + "static/media/Loader.56c68ab6.svg";